import { RegionData } from "types"

const getRegionName = (region: RegionData | null): string => {
    if (!region) return "-"
    if (region.name) return region.name
    return region.country?.name || "-"
}

export const RegionTypeCell = ({ value }: { value: RegionData | null }) => {
    return <span>{getRegionName(value)}</span>
}
